var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VideoPlayer"},[_c('video',{ref:"video",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url,"controls":"","disablePictureInPicture":true,"controlsList":"nodownload"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }